import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import SafeImage from "../components/SafeImage";

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [counts, setCounts] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([api.get("/categories"), api.get("/products")])
            .then(([c, p]) => {
                setCategories(c.data);
                const map = {};
                p.data.forEach((prod) => {
                    map[prod.category_slug] = (map[prod.category_slug] || 0) + 1;
                });
                setCounts(map);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="categories-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
            <nav className="flex items-center gap-1.5 text-xs text-brand-inkSoft mb-6">
                <Link to="/" className="hover:text-brand-ink">Início</Link>
                <ChevronRight className="w-3 h-3" />
                <span className="text-brand-ink font-semibold">Categorias</span>
            </nav>

            <header className="mb-10 sm:mb-14 max-w-2xl">
                <div className="text-[11px] uppercase tracking-[0.25em] font-bold text-brand-gold mb-2">Coleções</div>
                <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-ink tracking-tight">
                    Navegue por categoria
                </h1>
                <p className="mt-3 text-brand-inkSoft text-sm sm:text-base">
                    Encontre o que combina com seu estilo dentro da coleção Vitrine Deus Proverá.
                </p>
            </header>

            {loading ? (
                <div className="text-center py-20 text-brand-inkSoft" data-testid="categories-loading">Carregando…</div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                    {categories.map((c, i) => (
                        <Link
                            key={c.id}
                            to={`/produtos?categoria=${c.slug}`}
                            data-testid={`category-tile-${c.slug}`}
                            className="group relative overflow-hidden bg-brand-ink rounded-sm aspect-[4/3] sm:aspect-[3/2]"
                        >
                            <SafeImage
                                src={c.image}
                                alt={c.name}
                                loading="lazy"
                                decoding="async"
                                className="absolute inset-0 w-full h-full object-contain p-6 sm:p-10 transition-transform duration-700 group-hover:scale-[1.03]"
                                fallback={<div className="absolute inset-0 flex items-center justify-center text-brand-gold/30 text-6xl font-heading uppercase tracking-widest">{c.name?.[0] || "V"}</div>}
                            />
                            <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/15 to-transparent pointer-events-none" />
                            <div className="absolute inset-0 p-6 sm:p-8 flex flex-col justify-end">
                                <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-brand-gold mb-2">{counts[c.slug] || 0} produtos</div>
                                <h3 className="font-heading text-white font-semibold text-2xl sm:text-3xl tracking-tight">{c.name}</h3>
                                <p className="text-white/75 text-sm mt-1 max-w-md">{c.description}</p>
                                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-gold group-hover:text-white transition-colors">
                                    Explorar coleção <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Categories;
